/**
 * Utility Helpers
 * 
 * Shared utility functions used throughout the application.
 */

/**
 * Clamp a value between min and max
 */
export function clamp(v: number, a: number, b: number): number {
  return Math.max(a, Math.min(b, v));
}

/**
 * Generate unique IDs sequentially (00, 01, 02, ...)
 */
function createUidGenerator(): () => string {
  let i = 1;
  return () => String(i++).padStart(2, '0');
}

/**
 * Default UID generator instance
 */
export const uid = createUidGenerator();

